import { Component, Input, OnInit } from '@angular/core';
import {
	Label,
	LanguageService,
	StorageService,
	TempKey,
} from '@services/public';
import { ABSTRACT_PAGE, AbstractData } from '../common';

const PAGE_PATH: string = 'skillBuilders.abstract.pages.example';

@Component({
	selector: 'app-member-skill-builder-abstract-example',
	templateUrl: './example.component.html',
	styleUrls: ['./example.component.scss'],
})
export class MemberSkillBuilderAbstractExampleComponent implements OnInit {
	@Input() data: AbstractData;

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		subtitle: '',
	};
	labels: { [key: string]: string } = {
		[Label.NEXT]: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});
		this._languageSvc.getLabels(this.labels);
	}

	nextOnClick(): void {
		this._storageSvc.setTempStorage(TempKey.ABSTRACT, {
			...this.data,
			page: ABSTRACT_PAGE.IDEA,
		});
	}
}
